<template>
  <div class="deliverytype">
    <!-- Message for pre select and self pickup for CSC Survey -->
    <p>
      If you require multiple delivery methods or require delivery to multiple
      locations, please place separate orders.
    </p>

    <div class="msgforselfpickup" v-if="purpose === 'EXPORT'">
      We strongly encourage customers exporting their container to manage their
      own pick-up.
      <span
        href="#"
        class="pa3 btn"
        style="padding: 0"
        @click.stop="showRecommendation = true"
      >
        <v-icon style="color: white">info</v-icon>
      </span>

      <v-dialog v-model="showRecommendation" max-width="500px">
        <div class="dialog">
          <v-icon
            @click="showRecommendation = false"
            style="border-radius: 0.8em; background: #6dbe45"
            >close</v-icon
          >
          <h5>{{ hovermessage }}</h5>
        </div>
      </v-dialog>
    </div>
    <br />
    <div id="delivery">
      <label class="grow">
        <input
          type="radio"
          id="DELIVERY"
          :disabled="disableDelivery"
          value="DELIVERY"
          v-model="bind_Delivery"
        />
        <img :src="img_delivery" alt="Delivery logo" width="80%" />
        <figcaption style="font-size: 16px">
          Delivery Fee from {{ lineItemMarket }}:
          <span style="color: #6dbe45; font-size: 20px"
            >${{ lineItemHaulerPrice }}</span
          >
          <br />
          <small>Delivery 4-7 business days</small>
        </figcaption>
      </label>

      <label class="grow">
        <input
          type="radio"
          id="PICK-UP"
          :disabled="disableSelfpickup"
          value="PICK-UP"
          v-model="bind_Delivery"
        />
        <img :src="img_pickup" alt="Pickup logo" width="80%" />
        <figcaption style="font-size: 16px">
          No Additional Charge
          <br />
          <small>Pickup 1-3 business days</small>
          </figcaption>
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "Delivery",
  computed: {
    ...mapGetters({
      purpose: types.PURPOSE,
      delivery: types.DELIVERY,
      CART: types.CART_LIST,
      cscTerms: types.CSC_TERMS,
      currentSurveyObject: types.CURRENTSURVEYOBJECT,
      lineItemHaulerPrice: types.LINEITEMHAULERPRICE,
      lineItemMarket: types.LINEITEMMARKET,
    }),
    bind_Delivery: {
      get() {
        return this.delivery;
      },
      set(value) {
        this.updateDelivery(value);
      },
    },
  },
  data() {
    return {
      disableDelivery: false,
      disableSelfpickup: false,
      showRecommendation: false,
      hovermessage: `     
      Because we deliver containers directly to the ground, a customer who is planning to load their container and 
      then export it will need to hire a crane to load the container onto a chassis when it's picked up again. 
      We recommend customers use the same hauler that's taking the container to the port pick-up the container once it's been surveyed. 
      Please contact us if you have any questions.      
      `,
      img_delivery_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Delivery-Selected.png",
      img_delivery_not_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Delivery-Not-Selected.png",
      img_delivery:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Delivery-Selected.png",
      img_pickup_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Customer-Pick-up-Selected.png",
      img_pickup_not_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Customer-Pick-up-Not-Selected.png",
      img_pickup:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Customer-Pick-up-Not-Selected.png",
    };
  },
  mounted() {
    if (this.delivery === "DELIVERY") {
      this.img_delivery = this.img_delivery_selected;
      this.img_pickup = this.img_pickup_not_selected;
    } else if (this.delivery === "PICK-UP") {
      this.img_pickup = this.img_pickup_selected;
      this.img_delivery = this.img_delivery_not_selected;
    }
    this.disableDeliveryType();
  },
  methods: {
    ...mapActions({
      updateDelivery: types.ACTIONS_UPDATE_DELIVERY,
    }),
    disableDeliveryType() {
      //disbale delivery or selfpickup
      if (this.CART.length === 0) {
        this.disableDelivery = false;
        this.disableSelfpickup = false;
      } else {
        if (
          this.CART[0]["customAttributes"]["Delivery"].toUpperCase() ===
          "DELIVERY"
        )
          this.disableSelfpickup = true;
        else this.disableDelivery = true;
      }
    },
  },
  watch: {
    //watcher on vuex type and change the image accordingly
    delivery: function (newValue) {
      if (newValue === "DELIVERY") {
        this.img_delivery = this.img_delivery_selected;
        this.img_pickup = this.img_pickup_not_selected;
      } else if (newValue === "PICK-UP") {
        this.img_pickup = this.img_pickup_selected;
        this.img_delivery = this.img_delivery_not_selected;
      }
    },
    CART: function () {
      this.disableDeliveryType();
    },
  },
};
</script>

<style scoped>
input[type="radio"] {
  display: none;
}

input[type="radio"]:checked + img {
  border: 5px solid #6dbe45;
}

[type="radio"] + img {
  cursor: pointer;
  border-radius: 10px;
}

input[type="radio"]:disabled + img {
  cursor: not-allowed;
  opacity: 0.5;
}

.dialog {
  background-color: white;
  border-radius: 15px;
  padding: 15px;
}

figcaption {
  font-size: 20px;
  padding: 10px;
}
</style>
